/* For Best Practices https://facebook.github.io/create-react-app/docs/adding-custom-environment-variables*/
export const API_URL = "http://localhost:8089";
//export const API_URL = "http://rest-api-full-stack-rbn-102.cfapps.io";
//export const API_URL = 'https://restful-web-services-full-stack-bankend.cfapps.io'
export const JPA_API_URL = `${API_URL}/jpa`;
export const QA_API_URL = "http://localhost:8083";
